var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"field",attrs:{"type":_vm.type,"name":_vm.name},domProps:{"value":_vm.value},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }